import React, { Component, Fragment } from "react"
import PropTypes from "prop-types"
import { Portal } from "react-portal"
import { StyleSheetManager } from "styled-components"
import styles from "theme/style.css"

class StyledFrame extends Component {
  constructor() {
    super()

    this.state = {
      iframeEl: null,
      error: false,
      isLoading: true,
    }

    this.errorTimeout = 60000
    this.lastStyle = null
  }

  componentDidMount() {
    this.autosize()
  }

  autosize = () => {
    const { iframeEl, isLoading } = this.state

    if (iframeEl) {
      if (iframeEl.contentWindow) {
        iframeEl.contentWindow.document.body.style.margin = 0
      }
    }

    if (this.errorTimeout <= 0) {
      /* eslint-disable no-console */
      console.error("Unable to initialize player")
      /* eslint-enable no-console */
      this.setState({
        error: true,
      })
    } else if (!iframeEl) {
      this.errorTimeout -= 25
      requestAnimationFrame(this.autosize)
    } else if (iframeEl && iframeEl.contentWindow) {
      if (!iframeEl.contentWindow.document.body.querySelector("div")) {
        this.errorTimeout -= 25
        requestAnimationFrame(this.autosize)
      } else {
        const height = iframeEl.contentWindow.document.body.querySelector("div").offsetHeight
        if (!height) {
          this.errorTimeout -= 25
          requestAnimationFrame(this.autosize)
        } else {
          iframeEl.style.height = `${iframeEl.contentWindow.document.body.querySelector("div").offsetHeight}px`
          if (isLoading) {
            this.setState({
              isLoading: false,
            })
          }
          requestAnimationFrame(this.autosize)
        }
      }
    }
  }

  handleRef = (iframeEl) => {
    this.setState({
      iframeEl,
    })
  }

  render() {
    const { children, ...rest } = this.props
    const { error, iframeEl, isLoading } = this.state

    return (
      <Fragment>
        <iframe ref={this.handleRef} title='SpokenLayer Player' frameBorder='0' width='100%' />
        {iframeEl && (
          <StyleSheetManager target={iframeEl.contentDocument.head}>
            <Portal node={iframeEl.contentWindow.document.body}> {error ? <p>Unable to initialize player</p> : children}</Portal>
          </StyleSheetManager>
        )}
        {iframeEl && (
          <Portal node={iframeEl.contentDocument.head}>
            <link href='https://fonts.googleapis.com/css?family=Lato:300,400,700' rel='stylesheet' />
            <style>{styles.toString()}</style>
          </Portal>
        )}
      </Fragment>
    )
  }
}

StyledFrame.propTypes = {
  children: PropTypes.any,
}

export default StyledFrame



// WEBPACK FOOTER //
// ./src/components/organisms/Frame/index.js